import { VerticalAlignAddonSize } from '../../../hooks/useVerticalAlign';
import { TextPresetWithSkin } from '../../TextGeneric/types';
import { ListSize } from '../types';

import { BaseItem, Item, Option, Section } from './types';

export const addonSizeMap: Record<ListSize, VerticalAlignAddonSize> = {
    xs: '16',
    s: '16',
    m: '24',
};

export function getTextPreset(option?: BaseItem): TextPresetWithSkin {
    return option?.caption ? 'current-main + current-caption' : 'current-main';
}

export function isSection<ValueType extends string, TOption>(item: object): item is Section<ValueType, TOption> {
    return 'options' in item;
}

export function getOptionKey<ValueType extends string>(option: Option<ValueType>): ValueType {
    return option.value;
}

export function getItemKey<ValueType extends string, SectionType extends string>(
    item: Item<ValueType, SectionType>,
): ValueType | SectionType {
    return isOption(item) ? item.value : item.key;
}

export function isOption<ValueType extends string>(item: Item<ValueType>): item is Option<ValueType> {
    return 'value' in item;
}
